// Ls Point
export const SELECT_LS_POINT = [
    {
        value: -1,
        label: 'LS.Point: All'
    },
    {
        value: 1,
        label: 'Yes',
    },
    {
        value: 2,
        label: 'No',
    },
]

export const LS_POINT = 1;
export const NOT_LS_POINT = 2;

export const MAX_SIZE_IMAGE_TENANT_UPLOAD = 1;
export const MAX_UPLOAD_ALL_COLLECTION = 6;

export const REMOVE_IMAGE = 1
export const NOT_REMOVE_IMAGE = 2
export const MAX_HASH_TAG = 5
export const LOTTE_MALL_TYPE = 1

